import {
  ExclamationCircleOutlined,
  FileExcelOutlined,
  MergeCellsOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { CommandBar, MessageBar, MessageBarType, SearchBox } from "@fluentui/react";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { ProgressIndicator, Label } from "@fluentui/react";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";
import {
  Button,
  DatePicker,
  Empty,
  notification,
  Skeleton,
  Tooltip,
  Layout,
} from "antd";
import { toJS } from "mobx";
import { Observer, observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, createContext } from "react";
import {
  Clock,
  Edit3,
  FilePlus,
  FileText,
  RefreshCcw,
  Save,
  Sliders,
  Target,
} from "react-feather";
import { FilterCallOut } from "../../shared/FilterCallOut";
import { toAntPickerDate } from "../../Utility/modules/datePicker";
import FiscalizationStore from "../productiontarget/store/FiscalizationStore";
import PreferenceStore from "../../area/home/store/preferenceStore";
import formatNumber from "accounting-js/lib/formatNumber.js";
import "../productiontarget/styles/monthtarget.css";
import confirm from "antd/lib/modal/confirm";
import ReportStore from "../../shared/ReportStore";
const { Content } = Layout;
const fiscalizationstore = createContext(FiscalizationStore);
const Preferencestore = createContext(PreferenceStore);

const reportStoreCtx = createContext(ReportStore);
export const Fiscalization = observer(({ assetName }) => {
  const fiscalizationStore = useContext(fiscalizationstore);
  const reportStore = useContext(reportStoreCtx);
  const preferenceStore = useContext(Preferencestore);
  const { oilValuesDecimalPlaces } = preferenceStore.preference;

  useEffect(() => {
    async function loadFiscalizaions() {
      try {
        await fiscalizationStore.loadFiscalizationData();
      } catch (error) {
        notification.error({
          key: "error",
          message: "SPARS Feedback",
          description: error.message,
        });
      } finally {
        fiscalizationStore.isloading = false;
      }
    }
    loadFiscalizaions();
  }, [assetName, preferenceStore.preference]);

  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: oilValuesDecimalPlaces,
        thousand: ",",
      });
    }
  };

  const fiscalGrid = useRef(null);

  const sortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        rowDrag: true,
        valueGetter: function (params) {
          return "";
        },
        width: 80,
        hide: true,
        pivot: false,
      },
      {
        headerName: "Monthly Oil Poduction Fiscalization",
        headerClass: "oilheader",
        children: [
          {
            headerName: "Fiscalization Year",
            field: "fiscalizationYear",
            sortable: true,
            resizable: true,
            pivot: true,
            type: "numberColumn",
            hide: true,
            width: 80,
          },
          {
            headerName: "Fiscalization Month (M)",
            field: "fiscalizationMonth",
            sortable: true,
            resizable: true,

            width: 120,
            filter: true,
          },
          {
            headerName: "Fiscalization Month (MMM-YY)",
            field: "fiscalizationMonthModified",
            sortable: true,
            resizable: true,

            width: 170,
            filter: true,
          },
          {
            headerName: "Production Days",
            field: "numberOfDays",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            type: "numberColumn",
          },
          {
            headerName: "Gross Fiscalized (bbl)",
            field: "grossFiscalized",

            cellStyle: { textAlign: "right" },
            width: 170,
            sortable: true,
            resizable: true,
            type: "numberColumn",
            valueFormatter: formatDigitOil,
          },
        ],
      },

      {
        headerName: "Audit",

        children: [
          {
            headerName: "Remarks",
            field: "uploadedBy",

            sortable: true,
            resizable: true,
          },
          {
            headerName: "Value Set On",
            field: "uploadedOn",
            sortable: true,
            resizable: true,

            cellRenderer: function (props) {
              if (fiscalizationStore.hasImported) return null;
              return moment(props.data.uploadedOn).format(
                "ddd DD.MM.YYYY , h:mm:ss a"
              );
            },
          },
        ],
      },
    ],
  };
  const rowSelected = (grid) => {
    fiscalizationStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      fiscalizationStore.selRow = toJS(selrow.data);
    }
  };
  return (
    <Layout style={{ background: "#fff", padding: "10px" }}>
      <Content>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <SubPageHeaderTitle
                title={`${fiscalizationStore.mainStore.assetContextName}-OANDO Gross Oil Production Fiscalizations for ${fiscalizationStore.targetYear}`}
              />
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <CommandBar
                items={[
                  {
                    key: "d",
                    onRenderIcon: () => <FilterCallOut />,
                  },
                  {
                    key: "access",

                    text: (
                      <Tooltip title="perform quick query fiscalization values by year">
                        Fiscalization Year{" "}
                        <DatePicker
                          picker="year"
                          defaultValue={toAntPickerDate(`01-01-${fiscalizationStore.targetYear}`, "MM-DD-YYYY")}
                          allowClear={false}
                          format={"YYYY"}
                          onChange={async (date, dateString) => {
                            try {
                              fiscalizationStore.targetYear =
                                Number(dateString);
                              const prompt =
                                await fiscalizationStore.loadFiscalizationData();
                              if (prompt) {
                                fiscalizationStore.showEquityDialog = true;
                              }
                            } catch (error) {
                              notification.error({
                                key: "error",
                                message: "SPARS Feedback",
                                description: error.message,
                              });
                            }
                          }}
                        />
                      </Tooltip>
                    ),

                    onRenderIcon: () => <Clock className="qicon" />,
                  },
                  {
                    key: "refresh",
                    text: (
                      <Tooltip title="Refresh fiscalizations">Refresh</Tooltip>
                    ),

                    onRenderIcon: () => <RefreshCcw className="qicon" />,

                    onClick: async () => {
                      try {
                        await fiscalizationStore.loadFiscalizationData();
                      } catch (error) {
                        notification.error({
                          key: "error",
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      }
                    },
                  },
                  {
                    key: "modify",
                    text: (
                      <Tooltip
                        title={`Modify or edit selected monthly fiscalization figure for ${fiscalizationStore.selRow?.fiscalizationMonthModified}`}
                      >
                        Set{" "}
                        {fiscalizationStore.selRow?.fiscalizationMonthModified}{" "}
                        Fiscalization
                      </Tooltip>
                    ),
                    disabled: fiscalizationStore.disableCommand,
                    onRenderIcon: () => <Edit3 className="qicon" />,

                    onClick: async () => {
                      fiscalizationStore.showTargetEditDialog = true;
                    },
                  },

                  {
                    key: "spacer7",
                    onRender: () => <div style={{ width: "50px" }} />,
                  },

                  /*   {
                key: "fisc",

                name: "access",

                onRender: () => (
                  
                ),

                onRenderIcon: () => <Sliders className="qicon" />,
                onClick: () => {
                  //fiscalGrid.current.api.showNoRowsOverlay()
                },
              }, */
                  {
                    key: "spacer4",
                    onRender: () => <div style={{ width: "50px" }} />,
                  },
                  {
                    key: "search",
                    onRender: () => (
                      <Tooltip title="smart quick search on the fiscalization values displayed">
                        <SearchBox
                          placeholder="Search"
                          styles={{
                            root: {
                              width: "100%",
                              borderBottomColor: "#CBD5E0",
                            },
                          }}
                          underlined={true}
                          onChange={(ev, searchTerms) => {
                            fiscalGrid.current.api.setQuickFilter(searchTerms);
                          }}
                        ></SearchBox>
                      </Tooltip>
                    ),
                  },
                ]}
                farItems={[
                  {
                    key: "Qr1",

                    text: (
                      <Tooltip title="generate  fiscalization reports">
                        Reports
                      </Tooltip>
                    ),

                    onRenderIcon: () => <FileText className="qicon" />,

                    ariaLabel: "New",
                    subMenuProps: {
                      items: [
                        {
                          key: "emailMessage",
                          text: "Fiscalization Report",
                          iconProps: { iconName: "" },
                          onRenderIcon: () => <FilePlus className="qicon" />,
                          onClick: () => {
                            reportStore.reportParameters = {
                              Asset:
                                fiscalizationStore.mainStore.assetContextId,
                              Year: fiscalizationStore.targetYear,
                            };
                            reportStore.reportName =
                              "QikReach.Reporting.Naoc.Fiscalization,QikReach.Reporting";
                            reportStore.headerText =
                              "Oil Production Fiscalization Report";
                            reportStore.showReportDialog = true;
                          },
                        },
                      ],
                    },
                  },

                  {
                    key: "group4",

                    text: (
                      <Tooltip title="Export displayed fiscalizations values to excel">
                        Export to Excel
                      </Tooltip>
                    ),
                    name: "group",
                    onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                    onClick: () => {
                      fiscalGrid.current.api.exportDataAsExcel({
                        sheetName: "production fiscalization",
                        allColumns: true,

                        skipFooters: false,
                        skipGroups: false,
                        skipHeader: false,
                        skipPinnedTop: false,
                        skipPinnedBottom: false,
                        skipColumnGroupHeaders: false,
                        fileName: "fiscalization_data",
                        skipColumnHeaders: false,
                        columnGroups: true,
                      });
                    },
                  },
                ]}
              />
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {" "}
              {fiscalizationStore.isloading ? (
                <>
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                </>
              ) : (
                <div
                  className="ag-theme-balham qikreach-grid-fill"
                  style={{
                    minHeight: "50vh",
                    height: "65vh",
                    width: "100%",
                    maxHeight: "80vh",
                  }}
                >
                  {fiscalizationStore.fiscalizations?.size > 0 ||
                  (fiscalizationStore.importHasRows &&
                    fiscalizationStore.hasImported) ? (
                    <AgGridReact
                      rowData={
                        fiscalizationStore.importHasRows &&
                        fiscalizationStore.hasImported
                          ? [
                              ...fiscalizationStore.importedFiscalization.values(),
                            ].map((fiscalization) => {
                              return {
                                ...fiscalization,
                                fiscalizationMonthModified: `${moment(
                                  fiscalization.fiscalizationMonth,
                                  "MM"
                                ).format("MMM")}-${moment(
                                  fiscalizationStore.targetYear,
                                  "YYYY"
                                ).format("YY")}`,
                              };
                            })
                          : [...fiscalizationStore.fiscalizations.values()].map(
                              (fiscalization) => {
                                return {
                                  ...fiscalization,
                                  fiscalizationMonthModified: `${moment(
                                    fiscalization.fiscalizationMonth,
                                    "MM"
                                  ).format("MMM")}-${moment(
                                    fiscalizationStore.targetYear,
                                    "YYYY"
                                  ).format("YY")}`,
                                };
                              }
                            )
                      }
                      ref={fiscalGrid}
                      sideBar={["columns", "filters"]}
                      gridOptions={{
                        defaultColDef: {
                          sortable: true,
                          filter: true,
                          enableValue: true,
                          enableRowGroup: true,
                          enablePivot: true,
                        },
                        enableCharts: true,
                        enableRangeSelection: true,

                        rowSelection: "single",
                        pagination: true,
                        columnDefs: gridcolumnDefs.columnDefs,
                        animateRows: true,
                        statusBar: {
                          statusPanels: [
                            {
                              statusPanel: "agTotalRowCountComponent",
                              align: "center",
                            },
                          ],
                        },
                        columnTypes: {
                          numberColumn: {
                            width: 130,
                            filter: "agNumberColumnFilter",
                          },
                          medalColumn: {
                            width: 100,
                            columnGroupShow: "open",
                            filter: false,
                          },
                          nonEditableColumn: { editable: false },
                        },
                        sideBar: {
                          defaultToolPanel: "filters",
                        },
                      }}
                      rowSelection={{ mode: "singleRow", checkboxes: true, enableClickSelection: true }}
                      onSelectionChanged={rowSelected}
                      onSortChanged={sortChanged}
                      copyHeadersToClipboard={true}
                      overlayLoadingTemplate={`${(
                        <span class="ag-overlay-loading-center">
                          Please wait while your rows are loading
                        </span>
                      )}`}
                      overlayNoRowsTemplate={
                        '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
                      }
                    ></AgGridReact>
                  ) : (
                    <div className="ms-Grid" dir="ltr" style={{}}>
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{ textAlign: "center", paddingTop: "20px" }}
                        >
                          <MessageBar messageBarType={MessageBarType.warning}>This is initialized once in every fiscal year,Select <b>Fiscalization Year</b> of previous years to see the entry formats </MessageBar>
                          </div></div>
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{
                            height: "500px",
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <Empty
                            description={`${fiscalizationStore.mainStore.assetContextName}-OANDO Gross fiscalization for ${fiscalizationStore.targetYear} has not been initialized`}
                          />
                          <div className="ms-Grid-row">
                            <div
                              className="ms-Grid-col ms-sm12"
                              style={{
                                textAlign: "center",
                                paddingTop: "20px",
                              }}
                            >
                              {" "}
                              <Button
                                type="danger"
                                icon={<MergeCellsOutlined />}
                                onClick={() => {
                                  fiscalizationStore.hasImported = false;
                                  fiscalizationStore.showFiscalizationDialog = true;
                                }}
                              >
                                {`Initialize ${fiscalizationStore.mainStore.assetContextName}-OANDO Gross fiscalization for ${fiscalizationStore.targetYear}`}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

